import { NgStyle } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { BasePage } from '../../../@common/abstract/page.abstract';
import { AccordionComponent } from '../../../@ui/app/global/accordion/accordion.component';

@Component({
    selector: 'app-privacy-terms-of-use',
    templateUrl: './privacy-terms.page.html',
    styleUrls: ['./privacy-terms.page.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgStyle, AccordionComponent]
})
export default class PrivacyTermsPage extends BasePage {
    constructor() {
        super();

        this.setMeta({
            title: 'Videolectures - Privacy Policy & Terms of Use',
            description: 'Privacy Policy & Terms of Use',
            image: 'https://videolectures.net/assets/logo_big.png',
            index: true
        });
    }
}
